<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__boxformdetail}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('trade:boxformdetail:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('trade:boxformdetail:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
          <el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>
            <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>
            <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
            <el-table-column prop="deleted" label="逻辑删除" header-align="center" align="center"></el-table-column>
            <el-table-column prop="tenantId" label="租户" header-align="center" align="center"></el-table-column>
            <el-table-column prop="receiptCode" label="进出口发票号" header-align="center" align="center"></el-table-column>
            <el-table-column prop="shipDate" label="装船日期" header-align="center" align="center"></el-table-column>
            <el-table-column prop="productId" label="产品ID" header-align="center" align="center"></el-table-column>
            <el-table-column prop="formId" label="关联主表" header-align="center" align="center"></el-table-column>
            <el-table-column prop="agreementId" label="合同id" header-align="center" align="center"></el-table-column>
            <el-table-column prop="boxCount" label="箱数" header-align="center" align="center"></el-table-column>
            <el-table-column prop="preBoxCount" label="入数" header-align="center" align="center"></el-table-column>
            <el-table-column prop="totalCount" label="总数" header-align="center" align="center"></el-table-column>
            <el-table-column prop="totalSize" label="总体积" header-align="center" align="center"></el-table-column>
            <el-table-column prop="weight" label="毛重" header-align="center" align="center"></el-table-column>
            <el-table-column prop="preSize" label="单箱体积" header-align="center" align="center"></el-table-column>
            <el-table-column prop="boxLong" label="长" header-align="center" align="center"></el-table-column>
            <el-table-column prop="boxWidth" label="宽" header-align="center" align="center"></el-table-column>
            <el-table-column prop="boxHeight" label="高" header-align="center" align="center"></el-table-column>
            <el-table-column prop="factoryId" label="工厂" header-align="center" align="center"></el-table-column>
          <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('trade:boxformdetail:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('trade:boxformdetail:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './boxformdetail-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/boxformdetail/page',
        getDataListIsPage: true,
        exportURL: '/trade/boxformdetail/export',
        deleteURL: '/trade/boxformdetail',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
